import React, { useEffect, useRef, useState } from "react";
import { Badge, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Button } from "@/Components/ui";
;
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import toast, { Toaster } from 'react-hot-toast';
import { read, utils, writeFileXLSX, writeFile } from "xlsx";
import ServerPaginatedTable from "../../../Components/Common/ServerPaginatedTable";
import { API_RESERVATIONS, API_RESERVATION_ALL, BACKEND_HOST, changeReservationState, deleteReservationItem, getDataFromUrl, refundReservationItem } from "../../../api";
import moment from "moment";
import QueryString from "qs";
import DeleteOrRefundModal from "../../../Components/Common/DeleteOrRefundModal";
import ReservationChangeModal from "../../../Components/ReservationChangeModal";
import { dialogService } from "@/utils/dialogService";
import { buildServerListUrl } from "@/utils/serverListQuery";
import {
    formatLinkedGroupReservationPayment,
    formatLinkedGroupReservationSummary,
    getGroupReservationStatusLabel,
    getLinkedGroupReservationSourceLabel,
} from "../GroupReservationRequests/groupReservationAdmin.mjs";
function printDiv(elid) {
    var divContents = document.getElementById(elid).innerHTML;
    var a = window.open("", "", "height=700, width=500");
    a.document.write("<html>");
    a.document.write('<body><table class="custom-header-css table">');
    a.document.write(divContents);
    // console.log(divContents)
    a.document.write("</table></body></html>");
    a.document.close();
    a.print();
}
const ReservationList = () => {
    const navigate = useNavigate();
    const refetchRef = useRef<() => void>(() => {});
    const selectReservationState = [
        { label: "예약", value: "예약" }, // 구입후 기본 상태
        { label: "입장", value: "입장" }, // 예약날짜에 와서 입장한 상태
        { label: "외출", value: "외출" }, // 입장후 잠시 외출한 상태
        { label: "퇴장", value: "퇴장" },
        { label: "완료", value: "완료" }, // 사용 완료한 상태. 입장상태에서 날짜가 지나면 완료로 바꿈
        { label: "노쇼", value: "노쇼" }, // 예약날짜에 나타나지 않아서 환불도 불가한 상태
    ];
    const columns = React.useMemo(() => [
        {
            Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" onClick={() => checkedAll()}/>,
            Cell: (cellProps) => {
                return <input type="checkbox" className="customerCheckBox form-check-input" value={cellProps.row.original.id}/>;
            },
            id: "#",
        },
        {
            Header: "예약신청일",
            accessor: "예약신청일",
            id: "order__order_date",
            Cell: (cellProps) => {
                return <div>
            <div>{moment(cellProps.row.original["예약신청일"]).format("YYYY-MM-DD HH:mm")}</div>
            <div className="text-muted">#{cellProps.row.original["id"]}</div>
          </div>;
            },
        },
        {
            Header: "예약상품",
            accessor: "예약상품",
            id: "order",
            Cell: (cellProps) => {
                const groupReservation = cellProps.row.original["group_reservation"];
                return (<div>
              <div>{cellProps.row.original["예약상품"]}</div>
              {groupReservation ? (<div className="mt-1">
                  <Badge color="info" className="me-1">단체예약</Badge>
                  <div className="text-muted small">{formatLinkedGroupReservationSummary(groupReservation)}</div>
                  <div className="text-muted small">
                    {getLinkedGroupReservationSourceLabel(groupReservation)} · {getGroupReservationStatusLabel(groupReservation.status)} · 입금 {formatLinkedGroupReservationPayment(groupReservation)}
                  </div>
                </div>) : null}
            </div>);
            },
        },
        {
            Header: "자리",
            accessor: "자리",
            id: "spot",
            Cell: (cellProps) => {
                return (<div>
              <div>{cellProps.row.original["자리"]}</div>
              <Button color="primary" size="sm" onClick={() => { setTargetCell(cellProps.row.original); setShowChangeModal(true); }}>
                자리변경
              </Button>
            </div>);
            }
        },
        {
            Header: "예약자",
            accessor: "예약자",
            id: "order__user__username",
            Cell: (cellProps) => {
                return (<div>
              <div>{cellProps.row.original["예약자"]}</div>
              <div>{cellProps.row.original["번호"]}</div>
            </div>);
            },
        },
        {
            Header: "예약시작일",
            accessor: "예약시작일",
            id: "start_date",
            Cell: (cellProps) => {
                return <div>
            <div>{moment(cellProps.row.original["예약시작일"]).format("YYYY-MM-DD")}</div>
            <div className="text-muted">{moment(cellProps.row.original["예약종료일"]).format("YYYY-MM-DD")}</div>
          </div>;
            },
        },
        {
            Header: "예약상태",
            accessor: "예약상태",
            id: "state",
            Cell: (cellProps) => {
                const selref = useRef(null);
                useEffect(() => {
                    if (selref) {
                        // selref.current.value = cellProps.row.original['예약상태']
                        selref.current.setValue(selectReservationState.find((val) => {
                            return cellProps.row.original["예약상태"].valueOf() === val.value.valueOf();
                        }), "deselect-option");
                    }
                }, [cellProps, selref]);
                return (<>
              <Select ref={selref} className="mb-0" defaultValue={selectReservationState.find((val) => {
                        return cellProps.row.original["예약상태"].valueOf() === val.value.valueOf();
                    })} onChange={(val) => {
                        if (cellProps.row.original["예약상태"].valueOf() === val.value.valueOf())
                            return;
                        changeReservationState(cellProps.row.original.id, val.value).then((data) => {
                            console.log("changeReservationState", data);
                            toast.success(`예약상태를 변경하였습니다!\n : ${cellProps.row.original["예약자"]} ${cellProps.row.original["예약상태"]}=>${val.value}`, {
                                position: "top-right",
                                autoClose: 5000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                                theme: "light",
                            });
                            refetchRef.current();
                        });
                    }} options={selectReservationState} id={"choices-single-" + cellProps.row.original.id}></Select>
            </>);
            },
        },
        {
            Header: "선물",
            accessor: "gifted",
            id: "",
            Cell: (cellProps) => {
                return <span>{cellProps.row.original["gifted"] ? "선물됨" : null}</span>;
            },
        },
        {
            Header: "결제방법",
            accessor: "method",
            id: "method",
        },
        {
            Header: "Actions",
            accessor: "Actions",
            id: "",
            Cell: (cellProps) => {
                return (<div className="d-flex flex-row justify-content-end align-items-end gap-2">

              {cellProps.row.original.options && cellProps.row.original.options.length ? (<div className="edit align-self-center">
                  <Button size="sm" onClick={() => {
                            setTargetCell(cellProps.row.original);
                            setShowOptions(true);
                        }}>
                    옵션
                  </Button>
                </div>) : null}

              <div className="remove align-self-center">
                <div className="text-danger" style={{ cursor: "pointer" }} onClick={() => {
                        onClickDelete(cellProps.row.original.id);
                    }}>
                  <i className="ri-delete-bin-5-fill fs-16"></i>
                </div>
              </div>
            </div>);
            },
        },
    ], []);
    // const [modal, setModal] = React.useState(false);
    const [data, setData] = React.useState([]);
    const [previous, setPrevious] = React.useState("");
    const [next, setNext] = React.useState("");
    const [count, setCount] = React.useState("");
    const [dataQuery, setDataQuery] = React.useState({});
    const onRequestData = (_url) => {
        getDataFromUrl(_url)
            .then((data) => {
            setData(data.results);
            setPrevious(data.previous);
            setNext(data.next);
            setCount(data.count);
            // if (isSearch) calcTotalPageCount(data.count, (data.results).length);
        })
            .catch((e) => {
            console.log(e);
        });
    };
    const refetch = () => {
        onRequestData(buildServerListUrl(API_RESERVATIONS, dataQuery));
    };
    useEffect(() => {
        refetchRef.current = refetch;
    }, [refetch]);
    React.useEffect(() => {
        if (!previous && !next) {
            refetch();
        }
    }, []);
    const [checkedRecords, setCheckedRecords] = React.useState([]);
    const [deleteModal, setDeleteModal] = React.useState(false);
    const [deleteModalMulti, setDeleteModalMulti] = React.useState(false);
    const [showChangeModal, setShowChangeModal] = React.useState(false);
    const checkedAll = () => {
        const checkall = document.getElementById("checkBoxAll");
        const ele = document.querySelectorAll(".customerCheckBox");
        if (checkall.checked) {
            ele.forEach((ele) => {
                ele.checked = true;
            });
        }
        else {
            ele.forEach((ele) => {
                ele.checked = false;
            });
        }
    };
    const deleteRecords = async () => {
        const ele = document.querySelectorAll(".customerCheckBox:checked");
        const checkall = document.getElementById("checkBoxAll");
        if (ele.length === 0) {
            await dialogService.handleAlert("삭제할 항목이 없습니다.");
            return;
        }
        ele.forEach((element) => {
            console.log("reservation id:", element.value);
            deleteReservationItem(element.value)
                .then(async (data) => {
                console.log("deleteReservationItem:", data);
                if (data) {
                    await dialogService.handleAlert("삭제되었습니다.");
                    refetch();
                }
            })
                .catch(async (e) => {
                await dialogService.handleAlert("항목 삭제 실패했습니다!", { force: "error" });
                console.warn(e);
            });
            element.checked = false;
        });
    };
    const onClickDelete = (order) => {
        setCheckedRecords([order]);
        setDeleteModal(true);
    };
    const handleDeleteOrder = (cancelAmtount = 0) => {
        if (checkedRecords.length) {
            checkedRecords.forEach((value) => {
                console.log("reservation id:", value);
                deleteReservationItem(value, cancelAmtount)
                    .then(async (data) => {
                    console.log("deleteReservationItem:", data);
                    if (data.error) {
                        await dialogService.handleAlert("요청실패:" + data.error);
                        return;
                    }
                    refetch();
                })
                    .catch(async (e) => {
                    await dialogService.handleAlert("항목 삭제 실패했습니다!", { force: "error" });
                    console.warn(e);
                });
            });
            setDeleteModal(false);
        }
    };
    const handleRefundOrder = (cancelAmtount = 0) => {
        if (checkedRecords.length) {
            checkedRecords.forEach((value) => {
                console.log("reservation id:", value);
                refundReservationItem(value, cancelAmtount)
                    .then(async (data) => {
                    console.log("refundReservationItem:", data);
                    if (data.error) {
                        await dialogService.handleAlert("요청실패:" + data.error);
                        return;
                    }
                    toast.success(data.message, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                    refetch();
                })
                    .catch(async (e) => {
                    await dialogService.handleAlert("항목 삭제 실패했습니다!", { force: "error" });
                    console.warn(e);
                });
            });
            setDeleteModal(false);
        }
    };
    const [showOptions, setShowOptions] = useState(false);
    const toggleShowOptions = () => {
        setShowOptions(!showOptions);
    };
    const [targetCell, setTargetCell] = useState(null);
    const [packageProducts, setPackageProducts] = useState([]);
    useEffect(() => {
        getDataFromUrl(`${BACKEND_HOST}/package/items`).then((data) => {
            console.log("packageProducts", data);
            setPackageProducts(data);
        });
    }, []);
    return (<div className="page-content">
    <DeleteOrRefundModal show={deleteModal} onDeleteClick={handleDeleteOrder} onCloseClick={() => setDeleteModal(false)} onRefundClick={handleRefundOrder} itemPrice={checkedRecords[0] && data.find((item) => item.id === checkedRecords[0]) ? data.find((item) => item.id === checkedRecords[0])["결제금액"] : 0} packageRefundAmount={checkedRecords[0] && data.find((item) => item.id === checkedRecords[0]) ? data.find((item) => item.id === checkedRecords[0])["패키지환불금액"] : 0} totalRefundAmount={checkedRecords[0] && data.find((item) => item.id === checkedRecords[0]) ? data.find((item) => item.id === checkedRecords[0])["환불예상금액"] : 0}/>
      <DeleteModal show={deleteModalMulti} onDeleteClick={() => {
            deleteRecords();
            setDeleteModalMulti(false);
        }} onCloseClick={() => setDeleteModalMulti(false)}/>


      <ReservationChangeModal visible={showChangeModal} toggle={() => setShowChangeModal(!showChangeModal)} targetData={targetCell} refreshPage={refetch}/>

      <Modal isOpen={showOptions} onClose={toggleShowOptions} centered={true}>
        <ModalBody className="py-3 px-5">
          <div className="mt-2 text-left">
            <div className="mt-4 pt-2 fs-15 mx-sm-5">
              <h4>예약상세</h4>
              {targetCell && (<div className="mt-4">
                  <p className="text-muted mb-0">예약상품: {targetCell["예약상품"]}</p>
                  <p className="text-muted mb-0">자리: {targetCell["자리"]}</p>
                  <p className="text-muted mb-0">예약자: {targetCell["예약자"]}</p>
                  <p className="text-muted mb-0">예약시작일: {targetCell["예약시작일"]}</p>
                  <p className="text-muted mb-0">예약종료일: {targetCell["예약종료일"]}</p>
                  <p className="text-muted mb-0">예약상태: {targetCell["예약상태"]}</p>
                  <p className="text-muted mb-0">결제금액: {targetCell["결제금액"]}</p>
                  {targetCell["gifted"] && <p className="text-muted mb-0">선물상태: {targetCell["gifted"]}</p>}
                  <div className="text-muted mt-2">
                    옵션:{" "}
                    {targetCell.options.map((item, idx) => {
                return (<p className="text-muted mx-4 mb-0" key={idx}>
                          <span>{item.name} - </span>
                          <span>{item.price}원</span>
                          <span>&nbsp;{item.state}</span>
                        </p>);
            })}
                  </div>
                </div>)}
            </div>
          </div>
          <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
            <Button type="button" data-bs-dismiss="modal" onClick={() => {
            setShowOptions(false);
        }} color="light">
              Close
            </Button>
          </div>
        </ModalBody>
      </Modal>

      <Container fluid>
        <BreadCrumb title="예약관리" pageTitle="예약"/>
        <Row>
          <Col lg={12}>
            <Card id="orderList">
              <CardHeader className="card-header border-0">
                <div className="d-flex align-items-center">
                  <h5 className="card-title mb-0 flex-grow-1">예약 목록</h5>
                  <div className="flex-shrink-0">
                    <Button color="success" className="add-btn me-1" onClick={() => {
            navigate("/reservation-add-item/");
        }} id="create-btn">
                      새 예약 추가
                    </Button>
                    <Button onClick={async () => {
            await dialogService.handleAlert("액셀 파일을 다운로드합니다... 건수가 400건이 넘을 경우 파일에 누락될 수 있으니 유의하시기 바랍니다.");
            getDataFromUrl(`${API_RESERVATION_ALL}/?${QueryString.stringify(dataQuery)}`).then((data) => {
                // const rows = data.map(row => ({
                // // id	예약신청일	예약상품	자리	예약자	번호	예약시작일	이용기간	예약상태	결제상태	승인번호
                // }));
                const worksheet = utils.json_to_sheet(data);
                const workbook = utils.book_new();
                utils.book_append_sheet(workbook, worksheet, "id");
                writeFileXLSX(workbook, "output.xlsx");
            });
        }} color="soft">
                      <i className="ri-save-2-line"></i>
                    </Button>
                    <span style={{ padding: "4px" }}></span>
                    <Button onClick={() => {
            printDiv("reservations-table");
        }} color="soft">
                      <i className="ri-printer-line"></i>
                    </Button>
                    <span style={{ padding: "4px" }}></span>
                    <Button onClick={() => setDeleteModalMulti(true)} color="soft-danger">
                      <i className="ri-delete-bin-2-line"></i>
                    </Button>
                  </div>
                </div>
              </CardHeader>

              <CardBody className="pt-0 px-2">
                <div className="card-body pt-0 px-2">
                  <div>
                    <React.Fragment>
                      <ServerPaginatedTable id="reservations-table" url={API_RESERVATIONS} columns={columns} data={data} previous={previous} next={next} count={count} onRequestData={onRequestData} onChangeQuery={setDataQuery} categories={[
            { id: 0, title: "전체", state: "", icon: "ri-store-2-fill" },
            ...packageProducts.filter((item) => item && item["상태"].valueOf() === "노출중").map((item, idx) => ({ id: idx + 1, title: item["상품명"], search: item["상품명"], icon: "ri-store-2-fill" })),
        ]}/>
                    </React.Fragment>
                  </div>
                </div>

                <Toaster position="top-center"/>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>);
};
export default ReservationList;
